import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import CadreManagement from '../views/CadreManagement.vue'
import SmartParty from '../views/SmartParty.vue'
import DigitalVillage from '../views/DigitalVillage.vue'
import ComprehensiveGovernance from '../views/ComprehensiveGovernance.vue'
import SmartInspection from '../views/SmartInspection.vue'
import NotFound from '../views/NotFound.vue'
import { routeSeoConfig } from '../utils/seo'

Vue.use(VueRouter)

const homeSectionRoutes = [
  { path: '/about', scrollTo: 'about' },
  { path: '/contact', scrollTo: 'contact' },
  { path: '/products', scrollTo: 'products' }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to) {
    if (to.meta.scrollTo || to.hash) {
      return false
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: routeSeoConfig['/']
    },
    ...homeSectionRoutes.map(({ path, scrollTo }) => ({
      path,
      component: Home,
      meta: { scrollTo, ...routeSeoConfig[path] }
    })),
    {
      path: '/cadre-management',
      name: 'cadre-management',
      component: CadreManagement,
      meta: routeSeoConfig['/cadre-management']
    },
    {
      path: '/smart-party',
      name: 'smart-party',
      component: SmartParty,
      meta: routeSeoConfig['/smart-party']
    },
    {
      path: '/digital-village',
      name: 'digital-village',
      component: DigitalVillage,
      meta: routeSeoConfig['/digital-village']
    },
    {
      path: '/comprehensive-governance',
      name: 'comprehensive-governance',
      component: ComprehensiveGovernance,
      meta: routeSeoConfig['/comprehensive-governance']
    },
    {
      path: '/smart-inspection',
      name: 'smart-inspection',
      component: SmartInspection,
      meta: routeSeoConfig['/smart-inspection']
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
      meta: routeSeoConfig['/404']
    }
  ]
})

router.afterEach((to) => {
  const target = to.meta.scrollTo || (to.hash ? to.hash.replace('#', '') : '')
  if (target) {
    Vue.nextTick(() => {
      setTimeout(() => {
        const el = document.getElementById(target)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      }, 80)
    })
  }
})

export default router
